module.exports = __webpack_public_path__ + "static/camp_fail.9c7cb52f.svg";